<template>
  <div class="agent-page">
    <div class="page-header">
      <h2 class="page-title">招标文件详情</h2>
      <el-button type="primary" icon="el-icon-back" @click="handleBack">返回</el-button>
    </div>
    <div class="content-wrap">
      <!-- 基本信息 -->
      <div class="section-block">
        <div class="section-title">基本信息</div>
        <el-row :gutter="20" class="detail-row">
          <el-col :span="12">
            <div class="field">
              <span class="label">招标文件编号：</span>
              <span class="value">{{ detailData.bidInvitationDocumentsCode || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">招标文件名称：</span>
              <span class="value">{{ detailData.bidInvitationDocumentsName || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">文件类型：</span>
              <span class="value">{{ getDocumentTypeText(detailData.documentType) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">文件编制状态：</span>
              <span class="value">{{ getDocumentStatusText(detailData.documentPreparationStatus) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">开标时间：</span>
              <span class="value">{{ detailData.bidOpeningTime || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">解密截止时间：</span>
              <span class="value">{{ detailData.decryptionDeadline || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">创建时间：</span>
              <span class="value">{{ detailData.createTime || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">状态：</span>
              <span class="value">{{ getStatusText(detailData.status) }}</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 标段配置信息 -->
      <div class="section-block" v-if="detailData.bidSectionConfig">
        <div class="section-title">标段配置信息</div>
        <el-row :gutter="20" class="detail-row">
          <el-col :span="12">
            <div class="field">
              <span class="label">标段编号：</span>
              <span class="value">{{ detailData.bidSectionConfig.bidSectionCode || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">开标时间：</span>
              <span class="value">{{ detailData.bidSectionConfig.bidOpeningTime || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">解密截止时间：</span>
              <span class="value">{{ detailData.bidSectionConfig.decryptionDeadline || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">质疑提出截止时间：</span>
              <span class="value">{{ detailData.bidSectionConfig.questionDeadline || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">暗标评审：</span>
              <span class="value">{{ detailData.bidSectionConfig.isBlindReview === 1 ? '暗标' : '明标' }}</span>
            </div>
          </el-col>
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">价款形式代码：</span>
              <span class="value">{{ getPriceFormText(detailData.bidSectionConfig.priceFormCode) }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">投标有效期：</span>
              <span class="value">{{ detailData.bidSectionConfig.bidValidity ? detailData.bidSectionConfig.bidValidity +
                '天' : '-' }}</span>
            </div>
          </el-col> -->
          <el-col :span="12">
            <div class="field">
              <span class="label">是否收取保证金：</span>
              <span class="value">{{ detailData.bidSectionConfig.isChargeDepositPayment === 1 ? '是' : '否' }}</span>
            </div>
          </el-col>
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">保证金金额：</span>
              <span class="value">{{ formatDepositPayment(detailData.bidSectionConfig.depositPayment,
                detailData.bidSectionConfig.depositPaymentUnit) }}</span>
            </div>
          </el-col> -->
          <el-col :span="12">
            <div class="field">
              <span class="label">是否验证保证金/保函：</span>
              <span class="value">{{ detailData.bidSectionConfig.isVerifyDepositPayment === 1 ? '是' : '否' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">招标控制价：</span>
              <span class="value">{{ formatTenderControlPrice(detailData.bidSectionConfig.tenderControlPrice,
                detailData.bidSectionConfig.tenderControlPriceUnit) }}</span>
            </div>
          </el-col>
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">评审办法：</span>
              <span class="value">{{ detailData.bidSectionConfig.bidEvaluationMethod || '-' }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">文件开启方法：</span>
              <span class="value">{{ detailData.bidSectionConfig.bidDecryptionMethod || '-' }}</span>
            </div>
          </el-col> -->
          <el-col :span="12">
            <div class="field">
              <span class="label">是否允许联合体投标：</span>
              <span class="value">{{ detailData.bidSectionConfig.jointBiddingIsPermitted === 1 ? '是' : '否' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">是否需要资格审查：</span>
              <span class="value">{{ detailData.bidSectionConfig.qualificationReviewIsRequired === 1 ? '是' : '否'
              }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">是否需要报名：</span>
              <span class="value">{{ detailData.bidSectionConfig.isNeedRegister === 1 ? '是' : '否' }}</span>
            </div>
          </el-col>
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">投标文件递交方法：</span>
              <span class="value">{{ detailData.bidSectionConfig.submissionMethods || '-' }}</span>
            </div>
          </el-col> -->
        </el-row>
      </div>

      <!-- 标段信息列表 -->
      <div class="section-block" v-if="detailData.bidSectionList && detailData.bidSectionList.length > 0">
        <div class="section-title">标段信息</div>
        <el-table :data="detailData.bidSectionList" border stripe>
          <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
          <el-table-column label="标段编号" prop="bidSectionCode" min-width="180"></el-table-column>
          <el-table-column label="标段名称" prop="bidSectionName" min-width="300"></el-table-column>
          <el-table-column label="是否已选择" prop="isSelected" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isSelected === 1 ? 'success' : 'info'" size="small">
                {{ scope.row.isSelected === 1 ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 文件列表 -->
      <div class="section-block" v-if="fileList && fileList.length > 0">
        <div class="section-title">文件列表</div>
        <el-table :data="fileList" border stripe>
          <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
          <el-table-column label="文件名称" prop="fileName" min-width="300" show-overflow-tooltip></el-table-column>
          <el-table-column label="文件类型" prop="fileExtension" width="100" align="center"></el-table-column>
          <el-table-column label="文件大小" prop="fileSize" width="120" align="center">
            <template slot-scope="scope">
              {{ formatFileSize(scope.row.fileSize) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleDownloadFile(scope.row)">
                <i class="el-icon-download"></i> 下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 开标一览表 -->
      <div class="section-block" v-if="detailData.bidOpeningLists && detailData.bidOpeningLists.length > 0">
        <div class="section-title">开标一览表</div>
        <el-table :data="detailData.bidOpeningLists" border stripe>
          <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
          <el-table-column label="项目名称" prop="itemName" min-width="150"></el-table-column>
          <el-table-column label="类型" prop="itemType" width="120" align="center">
            <template slot-scope="scope">
              {{ getItemTypeText(scope.row.itemType) }}
            </template>
          </el-table-column>
          <el-table-column label="填报内容类型" prop="itemValueType" width="140" align="center">
            <template slot-scope="scope">
              {{ getItemValueTypeText(scope.row.itemValueType) }}
            </template>
          </el-table-column>
          <el-table-column label="单位" prop="itemUnit" width="100" align="center">
            <template slot-scope="scope">
              {{ getItemUnitText(scope.row.itemUnit) }}
            </template>
          </el-table-column>
          <el-table-column label="填报说明" prop="itemInstructions" min-width="200"></el-table-column>
          <el-table-column label="创建时间" prop="createTime" width="180"></el-table-column>
        </el-table>
      </div>

      <!-- 目录结构 -->
      <div class="section-block" v-if="detailData.catalogues && detailData.catalogues.length > 0">
        <div class="section-title">文件目录</div>
        <el-tree :data="detailData.catalogues" :props="treeProps" node-key="strId" default-expand-all
          class="catalogue-tree">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>
              <i class="el-icon-folder-opened" style="color: #409EFF; margin-right: 5px;"></i>
              {{ data.catalogueName }}
            </span>
            <span style="color: #999; font-size: 12px; margin-left: 10px;">
              {{ data.catalogueDescription }}
            </span>
          </span>
        </el-tree>
      </div>
    </div>
  </div>
</template>

<script>
import { getBidInvitationDocumentsDetail } from '@/api/agent/api'
import { getFileList } from '@/api/base/api'

export default {
  name: 'DetailUploadFile',
  data() {
    return {
      bidInvitationDocumentsCode: '',
      detailData: {},
      fileList: [], // 文件列表
      treeProps: {
        children: 'children',
        label: 'catalogueName'
      }
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    /**
     * 初始化页面
     */
    initPage() {
      this.bidInvitationDocumentsCode = this.$route.query.bidInvitationDocumentsCode
      if (!this.bidInvitationDocumentsCode) {
        this.$message.error('缺少招标文件编号参数')
        this.$router.go(-1)
        return
      }
      this.getBidInvitationDocumentsDetail()
    },

    /**
     * 获取招标文件详情
     */
    async getBidInvitationDocumentsDetail() {
      try {
        const res = await getBidInvitationDocumentsDetail({
          bidInvitationDocumentsCode: this.bidInvitationDocumentsCode
        })
        if (res.code === 200) {
          this.detailData = res.data || {}
          this.getFileList(res.data.fileGuid)
        } else {
          this.$message.error(res.msg || '获取招标文件详情失败')
        }
      } catch (error) {
        console.error('获取招标文件详情失败:', error)
        this.$message.error('获取招标文件详情失败，请重试')
      }
    },
    //  获取文件
    async getFileList(fileGuid) {
      if (!fileGuid) return
      try {
        const res = await getFileList(fileGuid)
        if (res.code === 200) {
          this.fileList = res.data || []
        }
      } catch (error) {
        console.error('获取文件列表失败:', error)
      }
    },

    /**
     * 格式化文件大小
     */
    formatFileSize(size) {
      if (!size || size === 0) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB', 'TB']
      let unitIndex = 0
      let fileSize = size
      while (fileSize >= 1024 && unitIndex < units.length - 1) {
        fileSize /= 1024
        unitIndex++
      }
      return `${fileSize.toFixed(unitIndex === 0 ? 0 : 2)} ${units[unitIndex]}`
    },

    /**
     * 下载文件
     */
    handleDownloadFile(fileInfo) {
      if (!fileInfo.fileUrl) {
        this.$message.error('文件下载地址不存在')
        return
      }
      try {
        const link = document.createElement('a')
        link.href = fileInfo.fileUrl
        link.download = fileInfo.fileName || '下载文件'
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.$message.success(`开始下载文件：${fileInfo.fileName}`)
      } catch (error) {
        console.error('下载文件失败:', error)
        this.$message.error('下载文件失败，请重试')
      }
    },

    /**
     * 获取文件类型文本
     */
    getDocumentTypeText(type) {
      const typeMap = {
        1: '文件',
        2: '补遗书',
        3: '澄清文件'
      }
      return typeMap[type] || '-'
    },

    /**
     * 获取文件编制状态文本
     */
    getDocumentStatusText(status) {
      const statusMap = {
        0: '未编制',
        1: '已编制'
      }
      return statusMap[status] || '-'
    },

    /**
     * 获取状态文本
     */
    getStatusText(status) {
      const statusMap = {
        0: '暂存',
        1: '已提交'
      }
      return statusMap[status] || '-'
    },

    /**
     * 获取价款形式文本
     */
    getPriceFormText(code) {
      const priceFormMap = {
        1: '金额',
        2: '费率',
        3: '单价',
        9: '其他'
      }
      return priceFormMap[code] || '-'
    },

    /**
     * 格式化保证金金额
     */
    formatDepositPayment(amount, unit) {
      if (!amount && amount !== 0) return '-'
      const unitText = unit === 1 ? '万元' : '元'
      return `${amount} ${unitText}`
    },

    /**
     * 格式化招标控制价
     */
    formatTenderControlPrice(price, unit) {
      if (!price && price !== 0) return '-'
      const unitText = unit === 1 ? '万元' : '元'
      return `${price} ${unitText}`
    },

    /**
     * 获取开标一览表项目类型文本
     */
    getItemTypeText(type) {
      const typeMap = {
        '1': '总价',
        '2': '费率',
        '3': '单价',
        '9': '其他',
        '0': '文本内容'
      }
      return typeMap[type] || '-'
    },

    /**
     * 获取填报内容类型文本
     */
    getItemValueTypeText(valueType) {
      const valueTypeMap = {
        0: '任意文本',
        1: '纯数字'
      }
      return valueTypeMap[valueType] || '-'
    },

    /**
     * 获取单位文本
     */
    getItemUnitText(unit) {
      const unitMap = {
        0: '元',
        1: '万元',
        2: '%'
      }
      return unitMap[unit] || '-'
    },

    /**
     * 返回上一页
     */
    handleBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/agent-common.css';

.content-wrap {
  width: 100%;
  background-color: #fff;
  padding: 20px;
  margin-top: 20px;
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}

.section-block {
  margin-bottom: 30px;
  padding: 20px;
  background: #fafafa;
  border-radius: 4px;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f4f7;
}

.detail-row {
  .field {
    display: flex;
    padding: 12px 0;
    line-height: 1.6;

    .label {
      min-width: 180px;
      color: #666;
      font-weight: 500;
    }

    .value {
      flex: 1;
      color: #333;
      word-break: break-all;
    }
  }
}

.catalogue-tree {
  background: #fff;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #EBEEF5;

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
}

::v-deep .el-table {
  margin-top: 10px;

  th {
    background-color: #f5f7fa;
    color: #333;
    font-weight: 600;
  }

  .el-table__empty-text {
    color: #999;
  }
}

::v-deep .el-tree-node__content {
  height: 36px;
  line-height: 36px;
}
</style>